import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default () => {
  return new Vuex.Store({
    state: {
      application: window.APPLICATION,
      datasets: {},
      selected: null,
      layers: null
    },
    getters: {
      tileserverUrl (state) {
        return state.application.apiUrl + '/remote-services/tileserver-koumoul/proxy'
      },
      config (state) {
        return state.application && state.application.configuration
      },
      datasetInfos (state, getters) {
        return getters.config && getters.config.datasets && Object.assign({}, ...getters.config.datasets.map(d => ({ [d.id]: d })))
      }
    },
    mutations: {
      setAny (state, params) {
        Object.assign(state, params)
      },
      toggle (state, layerId) {
        state.layers[layerId].visible = !state.layers[layerId].visible
      },
      filter (state, params) {
        state.layers[params.id] = { ...state.layers[params.id], filters: params.filters }
      }
    },
    actions: {
      async init ({ commit, dispatch, getters }) {
        const datasets = {}
        for (const layer of getters.config.layers) {
          try {
            datasets[layer.dataset.id] = (await axios.get(getters.datasetInfos[layer.dataset.id].href)).data
            if (layer.shapes.type === 'circle' && layer.shapes.radius.type === 'variable') {
              const params = { size: 1, select: layer.shapes.radius.field, sort: layer.shapes.radius.field, finalizedAt: getters.datasetInfos[layer.dataset.id].finalizedAt }
              const minValueCircle = (await axios.get(getters.datasetInfos[layer.dataset.id].href + '/lines', { params })).data.results.pop()[layer.shapes.radius.field]
              params.sort = '-' + params.sort
              const maxValueCircle = (await axios.get(getters.datasetInfos[layer.dataset.id].href + '/lines', { params })).data.results.pop()[layer.shapes.radius.field]
              Object.assign(datasets[layer.dataset.id], { minValueCircle, maxValueCircle })
            }
            if (layer.colors.rangeOptions && layer.colors.rangeOptions.scheme.computed) {
              const params = { size: 1, select: layer.colors.rangeOptions.field, sort: layer.colors.rangeOptions.field, finalizedAt: getters.datasetInfos[layer.dataset.id].finalizedAt }
              const minValueColor = (await axios.get(getters.datasetInfos[layer.dataset.id].href + '/lines', { params })).data.results.pop()[layer.colors.rangeOptions.field]
              params.sort = '-' + params.sort
              const maxValueColor = (await axios.get(getters.datasetInfos[layer.dataset.id].href + '/lines', { params })).data.results.pop()[layer.colors.rangeOptions.field]
              // if (layer.colors && layer.colors.rangeOptions && layer.colors.rangeOptions.ranges && layer.colors.rangeOptions.ranges.type === 'quantiles') {
              const percents = [0, ...Array.from({ length: layer.colors.rangeOptions.ranges.size - 1 }, (_, i) => (i + 1) * (100 / layer.colors.rangeOptions.ranges.size)), 100].join(',')
              const metrics = (await axios.get(getters.datasetInfos[layer.dataset.id].href + '/metric_agg', { params: { field: layer.colors.rangeOptions.field, metric: 'percentiles', percents, finalizedAt: getters.datasetInfos[layer.dataset.id].finalizedAt } })).data.metric
              // }
              Object.assign(datasets[layer.dataset.id], { minValueColor, maxValueColor, quantiles: metrics.map((m, i) => ({ min: i ? metrics[i - 1].value : undefined, max: m.value })).slice(1) })
            }
          } catch (err) {
            dispatch('setError', err)
          }
        }
        commit('setAny', { datasets })
      },
      async setError ({ state }, error) {
        console.error('report error', error)
        try {
          axios.post(state.application.href + '/error', { message: error.message || error })
        } catch (err) {
          console.log('Failed to report error', err)
        }
      }
    }
  })
}
